import LandingPageAnalyzeReducer from 'store/landing-page-analyze/reducers';

export { default as landingPageAnalyzeTypes } from 'store/landing-page-analyze/types';
export { default as landingPageAnalyzeSelectors } from 'store/landing-page-analyze/selectors';

export default LandingPageAnalyzeReducer;
